import { Component, Element, Host, Prop, Watch, forceUpdate, h } from '@stencil/core';
import { Consumer } from '@sydle/ui-utils';
import { getPosts } from '../../../api/blog-api/get-posts';
import { GetPostsparams as GetPostsParams } from '../../../types/blog';
import { renderComponent } from '../../../utils/render-utils';
import { ComponentContentType } from '../sy-blog-share-bar/share-bar.types';
@Component({
  tag: 'sy-blog-posts-list',
  styleUrl: './scss/index.scss',
  shadow: true,
})
export class SyBlogPostsList {
  private consumer: Consumer;
  @Element() el: HTMLSyBlogPostsListElement;

  /** */
  @Prop() getPostsParams?: GetPostsParams;

  /**
   * Defines if infinite scroll is enabled
   */
  @Prop() infiniteScroll = false;

  /**
   * Size of fetched pages
   */
  @Prop() postsPerPage = 9;

  /**   */
  @Prop() posts: any;

  /**
   * Cta Newsletter JSON component Prop
   */
  @Prop() ctaNewsletterComponent: ComponentContentType;

  /**
   * Banner JSON component Prop
   */
  @Prop() bannerComponentJson: ComponentContentType;

  /**
   * Text of the back to top button
   */
  @Prop() backToTopLabel: string;

  /**
   * Text of the content request button
   */
  @Prop() contentRequestLabel: string;

  @Watch('getPostsParams')
  resetList(): void {
    this.el.shadowRoot?.querySelector('sy-blog-card-list')?.resetList();
    forceUpdate(this.el);
  }

  connectedCallback() {
    this.consumer = new Consumer(this.el);
    this.consumer.subscribe('getPostsParams', (postsParams: any) => (this.getPostsParams = postsParams));
  }

  disconnectedCallback() {
    this.consumer.disconnect();
  }

  render() {
    if (!this.getPostsParams) return null;
    return (
      <Host>
        <div class="container" style={'false' && { paddingBottom: '24px' }}>
          <sy-blog-card-list
            pageSize={this.postsPerPage}
            infiniteScroll={this.infiniteScroll}
            backToTopLabel={this.backToTopLabel}
            bannerItems={this.bannerComponentJson}
            contentRequestLabel={this.contentRequestLabel}
            posts={this.posts}
            getCards={(pageIndex, pageSize) => {
              return getPosts({
                appIdentifier: this.getPostsParams?.appIdentifier || '',
                pageIndex: pageIndex || 0,
                pageSize: pageSize,
                params: {
                  tagIdentifier: this.getPostsParams?.tagIdentifier,
                  categoryIdentifier: this.getPostsParams?.categoryIdentifier,
                  categoryId: this.getPostsParams?.categoryId,
                  tagId: this.getPostsParams?.tagId,
                },
              }).then((response) => {
                return response;
              });
            }}
          ></sy-blog-card-list>
          {this.ctaNewsletterComponent ? renderComponent(this.ctaNewsletterComponent) : null}
        </div>
      </Host>
    );
  }
}
